import { useQuery } from '@tanstack/react-query'
import { currentQueryService } from 'utils/api/queries'

const useGetIp = () => {
  const query = useQuery<unknown, Error>({
    queryKey: ['useGetIp'],
    queryFn: () => currentQueryService.getIp(),
  })
  return query
}

export { useGetIp }
